import './styles.scss';

import Layout from '../../layout/MainLayout';
import React from 'react'

export default function AboutUsPage() {
  return (
    <Layout hasSnow={false}>
      <div className="container">
        <h1>Coming Soon</h1>
      </div>
    </Layout >
  )
}
